import { GlobalEvents } from '@/composables/useGlobalListeners'
import Bugsnag from '@bugsnag/js'
import DOMPurify from 'dompurify'

export default {
  mounted(el, binding) {
    if (binding.value || binding.value === undefined) {
      el.setAttribute('contenteditable', true)
      el.classList.add('editable')
      el.onblur = e => {
        const purifier = DOMPurify(window)
        const target = e.target as HTMLElement
        let sanitizedText = ''
        try {
          sanitizedText = purifier.sanitize(target.innerText)
        } catch (e: any) {
          Bugsnag?.notify(e)
          return console.error(e)
        }
        const data = {
          path: target.dataset.targetPath,
          value: sanitizedText,
        }
        window.dispatchEvent(
          new CustomEvent(GlobalEvents.INLINE_EDIT, {
            detail: data,
          })
        )
      }
    }
  },
}
